import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import intervalPlural from "i18next-intervalplural-postprocessor";
import de from "./translations/common/de.json";
import en from "./translations/common/en.json";
import {setLanguageHeader} from "../api";
import {muiThemeLocaleAdapter} from "./MuiThemeLocaleAdapter.ts";

export const defaultNS = "common";
export const resources = {
    de: {
        common: de
    },
    en: {
        common: en
    }
} as const;

void i18n
    .use(LanguageDetector)
    .use(intervalPlural)
    .use(initReactI18next).init({
        debug: true,
        fallbackLng: Object.keys(resources)[1],
        interpolation: {
            escapeValue: false // not needed for react as it escapes by default
        },
        ns: [defaultNS],
        defaultNS,
        resources,
    }).then(_res => {
        let previousLanguage = i18n.language;

        i18n.on("languageChanged", lng => {
            if (previousLanguage === lng) return;

            previousLanguage = lng;
            muiThemeLocaleAdapter.setLocale(lng);
            setLanguageHeader(lng);
        });
    });

export default i18n;
